import type { FaireProductEntity } from "../../entity_types/product";

export const p_5xb47q633b: FaireProductEntity = {
  token: "p_5xb47q633b",
  type: "product",
  name: "Sleep Support Tonic",
  brandToken: "b_qsv28vpreq",
  brandName: "Zuma Nutrition",
  imageUrl:
    "https://cdn.faire.com/fastly/4a41b0e688e6856819faa2b09c567c9aa817eb4c371fd360e666b7b8faacc75d.png",
  galleryImageUrls: [],
  priceDollars: 23.97,
  description:
    "Potential Benefits May Include:\n\n * Promotes Restful Sleep† \n * Supports Relaxation and Recovery† \n * Supports a Calm Mind† \n * Supports Healthy Immune Response† \n * Water Soluble Liquid = Better Absorption than Capsules or Powders \n * Therapeutic “Active Ingredient” Extraction to Increase the Potency \n * Fresh (Not Dried) Wild harvested Raw Ingredients \n * Manufactured in Small Curated Batches ",
  tags: [],
  msrpDollars: 39.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:22.743Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
